import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { AppSettings } from '../shared/AppSettings';

@Injectable()
export class DocumentService {
  readonly rootUrl = AppSettings.webApiURL; 

  constructor(public httpClient: HttpClient) { }

  public InitDocument() {
    return this.httpClient.get(`${this.rootUrl}/api/DocumentApi/InitDocument`);
  }

  public getSuppliers() {
    return this.httpClient.get(`${this.rootUrl}/api/CustomerOrder/GetCustomerSuppliers`);
  }

  public getAttachments() {
    return this.httpClient.get(`${this.rootUrl}/api/DocumentApi/GetAttachments`);
  }

  public removeAttachment(name) {
    return this.httpClient.get(`${this.rootUrl}/api/DocumentApi/RemoveAttachment?name=${name}`);
  }

  public saveDocument(document) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/DocumentApi/SaveDocument`, document, { headers });
  }

  public saveDocumentProfit(document) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/DocumentApi/SaveDocumentProfit`, document, { headers });
  }

  public getDocumentList() {
    return this.httpClient.get(`${this.rootUrl}/api/DocumentApi/GetDocumentList`);
  }

  public getDocumentProfitList(profitOrderNum) {
    return this.httpClient.get(`${this.rootUrl}/api/DocumentApi/GetDocumentProfitList?profitOrderNum=${profitOrderNum}`);
  }

  public getMessage(message) {
    const headers = new HttpHeaders({ 'No-Auth': 'True' }).set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/DocumentApi/ViewMessage`, message, { headers });
  }

  public downloadAttachment(documentId) {
    const headers = new HttpHeaders({ 'No-Auth': 'True' }).set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/DocumentApi/DownloadAttachment`, documentId, { headers, responseType: 'blob' });
  }

  // public downloadAttachmentGet(message) {
  //   return this.httpClient.get(`${this.rootUrl}/api/DocumentApi/DownloadAttachmentGet?m=${message.m}&g=${message.g}&c=${message.c}&f=${message.f}`, { responseType: 'blob' });
  // }

  public getDocumentFileStream(documentFilterByDocumentIdEncoded) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/DocumentApi/GetDocumentFileStream`, documentFilterByDocumentIdEncoded, { headers });
  }

  public getDocumentFile(documentFilterByDocumentIdEncoded) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/DocumentApi/GetDocumentFile`, documentFilterByDocumentIdEncoded, { headers, responseType: 'blob' });
  }


}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/service/document.service.ts